import { render, staticRenderFns } from "./Kf.vue?vue&type=template&id=4c531b87&scoped=true"
import script from "./Kf.vue?vue&type=script&lang=js"
export * from "./Kf.vue?vue&type=script&lang=js"
import style0 from "./Kf.vue?vue&type=style&index=0&id=4c531b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c531b87",
  null
  
)

export default component.exports